module.exports = __webpack_public_path__ + "static/media/OurTeam.93f99c40.jpg";